import { mapActions } from 'vuex';
import { ToastProgrammatic as Toast } from 'buefy';
import Draggable from 'vuedraggable';
import useVuelidate from '@vuelidate/core';
import { helpers } from '@vuelidate/validators';

import { required } from '@/utils/validators';
import {
  GET_DEPARTMENT_LIST,
  UPDATE_DEPARTMENT_INFO,
  GET_TEAM_INFO,
  UPDATE_TEAM_INFO,
} from '@/store/setting/constants';

export default {
  name: 'SettingOverview',
  setup() {
    return { v$: useVuelidate() };
  },
  components: {
    Draggable,
  },
  data() {
    return {
      identification: '',
      loading: false,
      teamInfo: {
        name: '',
        enablePickupCode: false,
      },
      departmentInfo: {
        departments: [],
        deleted_ids: [],
      },
      planName: '',
    };
  },
  computed: {
    departments() {
      return this.departmentInfo?.departments || [];
    },
  },
  async mounted() {
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.loading = true;
      const {
        name,
        departments,
        enable_pickup_code: enablePickupCode,
        identification,
        plan_name: planName = '',
      } = await this.getTeamInfo();

      this.teamInfo = { name, enablePickupCode };
      this.departmentInfo.departments = departments;
      this.identification = identification;
      this.planName = planName;
    } catch (ex) {
      const errorMessage = ex.message ? `(${ex.message})` : '';

      Toast.open({
        type: 'is-danger',
        message: `無法讀取帳戶資訊，請稍後再試${errorMessage}`,
      });
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async onCreateDepartment() {
      this.departmentInfo.departments.push({ name: '' });
      this.v$.departmentInfo.$touch();
    },
    async onRemoveDepartment(index) {
      const { departmentInfo } = this;
      const targetId = departmentInfo.departments[index].id;

      departmentInfo.departments.splice(index, 1);
      this.v$.departmentInfo.$touch();
      if (targetId) {
        departmentInfo.deleted_ids = departmentInfo.deleted_ids || [];
        departmentInfo.deleted_ids.push(targetId);
      }
    },
    async onSubmitDepartment() {
      try {
        this.loading = true;

        /* Remove empty field */
        this.departmentInfo.departments = this.departmentInfo.departments.filter((d) => d.name);

        await this.updateDepartmentInfo(this.departmentInfo);

        const { departments } = await this.getTeamInfo();
        this.departmentInfo.departments = departments;

        this.v$.departmentInfo.$reset();
        Toast.open({
          type: 'is-success',
          message: '部門資訊已更新',
        });
      } catch (ex) {
        const errorMessage = ex.message ? `(${ex.message})` : '';

        Toast.open({
          type: 'is-danger',
          message: `無法更新部門資訊，請稍後再試${errorMessage}`,
        });
      } finally {
        this.loading = false;
      }
    },
    async onSubmitTeamInfo() {
      try {
        this.loading = true;
        const { name, enablePickupCode } = this.teamInfo;
        await this.updateTeamInfo({
          enable_pickup_code: enablePickupCode,
          name,
        });
        Toast.open({
          type: 'is-success',
          message: '公司資訊已更新',
        });
      } catch (ex) {
        const errorMessage = ex.message ? `(${ex.message})` : '';

        Toast.open({
          type: 'is-danger',
          message: `無法更新公司資訊，請稍後再試${errorMessage}`,
        });
      } finally {
        this.v$.teamInfo.$reset();
        this.loading = false;
      }
    },
    ...mapActions('setting', {
      getDepartmentList: GET_DEPARTMENT_LIST,
      updateDepartmentInfo: UPDATE_DEPARTMENT_INFO,
      getTeamInfo: GET_TEAM_INFO,
      updateTeamInfo: UPDATE_TEAM_INFO,
    }),
  },
  validations() {
    return {
      teamInfo: {
        name: { required: required('公司名稱') },
        enablePickupCode: {},
      },
      departmentInfo: {
        departments: {
          $each: helpers.forEach({
            name: {
              required: required('部門名稱'),
            },
          }),
        },
      },
    };
  },
};
